jQuery(document).ready(function($) {

/* ====================== ACTIVE NAV ======================  */
$('#nav-icon').click(function(){
	$(this).toggleClass('active-nav');
	$('.mobile-nav').toggleClass('active-menu');
	$('body').toggleClass('disable-scroll');
});

/* ====================== Change Header Styling (Homepage) ======================  */
	$('.hp-masthead').waypoint(function() {
		$('header').toggleClass('active');
	}, {
		offset: '-50vh'
	});

/* ====================== Sub Menu ======================  */
	 $('#equipment-link').mouseenter(function() {
		$('.sub-menu-strip').show();
	});

	 $('header').mouseleave(function() {
		$('.sub-menu-strip').hide();
	});

	 $('.sub-menu-strip').mouseleave(function() {
		$('.sub-menu-strip').hide();
	});
 /* ====================== Disable Map Scroll ======================  */
	$('.acf-map').click(function () {
		$('.acf-map .gm-style').css("pointer-events", "auto");
	});

	$( ".acf-map" ).mouseleave(function() {
		$('.acf-map .gm-style').css("pointer-events", "none");
	});

/* ====================== Masthead ======================  */
	var owl = $('.hp-masthead-inner');
	owl.owlCarousel({
	dots: false,
	nav: false,
	loop:($(".hp-masthead-inner .item").length > 1) ? true: false,
	autoplay: true,
	items: 1,
	autoplayTimeout:5000,
	animateIn: 'fadeIn',
	animateOut: 'fadeOut',
	})

/* ====================== Testimonials Strip ======================  */
	var owl = $('.testimonials-inner');
	owl.owlCarousel({
	dots: true,
	nav: false,
	loop:($(".testimonials-inner .item").length > 1) ? true: false,
	autoplay: true,
	items: 1,
	autoplayTimeout:9000,
	autoHeight: true,
	margin: 50
	})

/* ====================== Smooth Scrolling ======================  */
$('a[href*="#"]')
	.not('[href="#"]')
	.not('[href="#0"]')

	.click(function(event) {
		if (
			location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {

      			var target = $(this.hash);
     			 target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

      			if (target.length) {
        				event.preventDefault();

       				 $('html, body').animate({
          				scrollTop: target.offset().top
        				}, 1000, function() {
        					var $target = $(target);
          					$target.focus();
				          		if ($target.is(":focus")) {
				            		return false;
				         		} else {
            						$target.attr('tabindex','-1');
            						$target.focus();
          						};
       					 });
      				}
    			}
 		 });
});
